/**
 * Optimizes Unsplash image URLs by adjusting the width parameter.
 * Non-Unsplash URLs are returned unchanged.
 */
export function optimizeImageUrl(url: string, width: number): string {
  if (!url.includes('unsplash.com')) return url;

  // Replace or append w= parameter
  let result = /[?&]w=\d+/.test(url)
    ? url.replace(/([?&]w=)\d+/, `$1${width}`)
    : `${url}${url.includes('?') ? '&' : '?'}w=${width}`;

  // Add quality compression to reduce file size (Unsplash default ~75)
  if (!/[?&]q=\d+/.test(result)) {
    result += '&q=70';
  }
  return result;
}

/** Category-based fallback images (stable, verified Unsplash URLs) */
const FALLBACK_IMAGES: Record<string, string> = {
  'camping': 'https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=800&auto=format&fit=crop',
  'mobile-living': 'https://images.unsplash.com/photo-1533591380348-14193f1de18f?w=800&auto=format&fit=crop',
  'off-grid-homes': 'https://images.unsplash.com/photo-1449158743715-0a90ebb6d2d8?w=800&auto=format&fit=crop',
  'boat-living': 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800&auto=format&fit=crop',
};

const DEFAULT_FALLBACK = 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=800&auto=format&fit=crop';

/** Get a fallback image URL for a given category */
export function getFallbackImage(category?: string): string {
  return (category && FALLBACK_IMAGES[category]) || DEFAULT_FALLBACK;
}
